import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const PortletFooter = props => {
  const { className, noDivider, children, sx, ...rest } = props;
  const theme = useTheme();

  const rootStyling = {
    paddingBottom: theme.spacing(1),
    paddingTop: theme.spacing(1),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    borderTop: noDivider ? 'none' : `1px solid ${theme.palette.border}`,
    borderBottomLeftRadius: '2px',
    borderBottomRightRadius: '2px',
  };

  return (
    <Box {...rest} sx={[rootStyling, ...(Array.isArray(sx) ? sx : [sx])]} className={className}>
      {children}
    </Box>
  );
};

PortletFooter.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  noDivider: PropTypes.bool,
  sx: PropTypes.oneOfType([PropTypes.object, PropTypes.array, PropTypes.func]),
};

PortletFooter.defaultProps = {
  children: undefined,
  className: 'portlet-footer',
  noDivider: false,
  sx: undefined,
};

export default PortletFooter;
